module.exports = __webpack_public_path__ + "img/12.98829db7.jpg";